import React from "react";
import { Box } from "@mui/material";
import SupplierAwardList from "../../SupplierAwardList";
import HorizontalBarChart from "../../HorizontalBarChart";
import StatusCardList from "../../StatusCardList";
import styles from "./analyticsDashboard.module.scss";

interface AnalyticsDashboardProps {
  awardBySuppliers?: any[];
  awardByCategory?: any[];
  awardByCommodity?: any[];
  awardByEntityUSD?: any[];
  awardByEntityPOCount?: any[];
  prByStatus?: any[];
}

const AnalyticsDashboard: React.FC<AnalyticsDashboardProps> = ({
  awardBySuppliers = [],
  awardByCategory = [],
  awardByCommodity = [],
  awardByEntityUSD = [],
  awardByEntityPOCount = [],
  prByStatus = [],
}) => {
  return (
    <>
      <Box className={styles.topSection}>
        <SupplierAwardList
          title="Award by Suppliers (USD)"
          data={awardBySuppliers}
          supplierKey="supplier"
          valueKey="value"
          poCountKey="poCount"
          countLabel="POs"
        />
        {/* Commented out - replaced with Award by Commodity (USD) */}
        {/* <SupplierAwardList
          title="Award by Category (USD)"
          data={awardByCategory}
          supplierKey="category"
          valueKey="value"
        /> */}
        <SupplierAwardList
          title="Award by Commodity (USD)"
          data={awardByCommodity}
          supplierKey="commodity"
          valueKey="value"
        />
      </Box>

      <Box className={styles.middleSection}>
        <HorizontalBarChart
          title="Award by Entity (USD)"
          data={awardByEntityUSD}
          nameKey="entity"
          valueKey="value"
          barColor="#00d2aa"
          valueLabel="USD"
          excelFileName="Award_by_Entity_USD"
          itemsPerPage={5}
        />
        <HorizontalBarChart
          title="Award by Entity (PO Count)"
          data={awardByEntityPOCount}
          nameKey="entity"
          valueKey="count"
          barColor="#5b6b9e"
          valueLabel="POs"
          excelFileName="Award_by_Entity_PO_Count"
          itemsPerPage={5}
        />
      </Box>

      {/* <StatusCardList title="PR by Status" data={prByStatus} /> */}
    </>
  );
};

export default AnalyticsDashboard;
